export const QUESTION_CATALOG = {
    "Animals": {
        "count": 91,
        "themes": {
            "Amphibians": 2,
            "Baby Animals": 4,
            "Behavior": 2,
            "Big Cats": 4,
            "Birds & Flight": 14,
            "Fun Facts": 6,
            "Indian Wildlife": 7,
            "Insects & Arachnids": 8,
            "Mammals": 22,
            "Marine Life": 8,
            "Records": 6,
            "Reptiles": 6,
            "Sleep & Behavior": 2
        }
    },
    "Anime": {
        "count": 92,
        "themes": {
            "Akira": 1,
            "Anime Terms": 3,
            "Attack on Titan": 5,
            "Chainsaw Man": 1,
            "Classics": 2,
            "Cowboy Bebop": 2,
            "Crayon Shin-chan": 4,
            "Death Games": 1,
            "Death Note": 5,
            "Demon Slayer": 3,
            "Detective Conan": 1,
            "Doraemon": 7,
            "Dragon Ball": 8,
            "Films": 2,
            "Fullmetal Alchemist": 3,
            "Hunter x Hunter": 2,
            "JoJo's Bizarre Adventure": 2,
            "Jujutsu Kaisen": 1,
            "My Hero Academia": 3,
            "Naruto": 7,
            "Neon Genesis Evangelion": 2,
            "One Piece": 7,
            "Pokémon": 7,
            "Sports Anime": 1,
            "Spy × Family": 2,
            "Studio Ghibli": 7,
            "Studios": 2,
            "Sword Art Online": 1
        }
    },
    "Art": {
        "count": 100,
        "themes": {
            "Abstract Expressionism": 1,
            "American Art": 4,
            "Architecture": 11,
            "Art Movements": 5,
            "Art Nouveau / Symbolism": 1,
            "Art Techniques": 10,
            "Artist Biographies": 2,
            "Artist Periods": 1,
            "Asian Art": 14,
            "Color Theory": 5,
            "Dutch Golden Age": 2,
            "Famous Paintings": 11,
            "Impressionism": 2,
            "Indian Dance": 6,
            "Land Art / Installation": 1,
            "Muralism": 1,
            "Museums & Collections": 3,
            "Northern Renaissance": 1,
            "Pop Art": 2,
            "Pop Art / Sculpture": 1,
            "Renaissance Masters": 6,
            "Sculpture": 7,
            "Street Art": 1,
            "Surrealism": 2
        }
    },
    "BoardGames": {
        "count": 85,
        "themes": {
            "7 Wonders": 1,
            "Awards": 3,
            "Azul": 3,
            "Battleship": 1,
            "Betrayal at House on the Hill": 3,
            "Carcassonne": 2,
            "Catan": 3,
            "Checkers": 1,
            "Chess": 1,
            "Classic Games": 25,
            "Clue": 1,
            "Codenames": 3,
            "Connect Four": 1,
            "Dixit": 3,
            "Dominion": 2,
            "Gloomhaven": 2,
            "Go": 1,
            "Jenga": 1,
            "Mahjong": 1,
            "Monopoly": 6,
            "Pandemic": 2,
            "Risk": 2,
            "Root": 1,
            "Scrabble": 3,
            "Scythe": 1,
            "Secret Hitler": 3,
            "Terraforming Mars": 2,
            "Ticket to Ride": 3,
            "Trivial Pursuit": 1,
            "Wingspan": 3
        }
    },
    "Bollywood": {
        "count": 182,
        "themes": {
            "Awards & Records": 9,
            "Classics": 20,
            "Directors & Writers": 21,
            "Modern Hits": 48,
            "Songs & Music": 29,
            "Stars": 51,
            "Trivia": 4
        },
        "liveFrom": "2026-10-22"
    },
    "Capitals": {
        "count": 113,
        "themes": {
            "African Capitals": 12,
            "Asian Capitals": 19,
            "Central Asian Capitals": 1,
            "European Capitals": 27,
            "Geography Records": 3,
            "Indian State Capitals": 25,
            "Middle Eastern Capitals": 9,
            "North American Capitals": 4,
            "Oceania Capitals": 1,
            "Planned Capitals": 2,
            "South American Capitals": 8,
            "Transcontinental Capitals": 1,
            "World Capitals": 1
        }
    },
    "Cars": {
        "count": 86,
        "themes": {
            "American Muscle": 2,
            "American Sports Cars": 1,
            "Automotive Groups": 1,
            "Automotive History": 10,
            "Automotive Technology": 1,
            "Automotive Terms": 8,
            "Brand Logos": 8,
            "Drivetrain": 2,
            "Electric Vehicles": 4,
            "Engine Technology": 4,
            "Engine Types": 2,
            "European Supercars": 1,
            "Formula 1": 1,
            "German Engineering": 1,
            "Hypercars": 2,
            "Indian Cars": 14,
            "Industry": 2,
            "Japanese Performance": 2,
            "Japanese Sports Cars": 1,
            "Land Speed Records": 1,
            "Luxury Brands": 1,
            "Nissan": 2,
            "Performance Cars": 1,
            "Performance Tech": 2,
            "Racing": 1,
            "Racing & Testing": 4,
            "Racing History": 1,
            "SUVs & Off-Road": 1,
            "Sales Records": 1,
            "Speed Records": 2,
            "Sports Cars": 1,
            "Vehicle Dynamics": 1
        }
    },
    "Chess": {
        "count": 87,
        "themes": {
            "Chess & Pop Culture": 1,
            "Chess & Technology": 4,
            "Chess Basics": 19,
            "Chess History": 6,
            "Chess Legends": 8,
            "Chess Rules": 15,
            "Chess Titles": 1,
            "Chess Variants": 1,
            "Indian Chess": 14,
            "Openings": 4,
            "Special Moves": 4,
            "Strategy": 5,
            "Tactics": 5
        }
    },
    "Cocktails": {
        "count": 81,
        "themes": {
            "Aperitivo": 1,
            "Brandy Cocktails": 2,
            "Brazilian Cocktails": 1,
            "Brunch Cocktails": 1,
            "Classic Cocktails": 14,
            "Creamy Cocktails": 1,
            "Garnishes": 1,
            "Gin Cocktails": 7,
            "Highballs": 1,
            "Modern Classics": 6,
            "New Orleans Cocktails": 2,
            "Pop Culture Cocktails": 1,
            "Prohibition Cocktails": 7,
            "South American Cocktails": 1,
            "Spirits": 2,
            "Technique Cocktails": 1,
            "Tequila Cocktails": 6,
            "Tiki & Tropical": 12,
            "Vodka Cocktails": 6,
            "Whiskey Cocktails": 8
        }
    },
    "Collective Nouns": {
        "count": 82,
        "themes": {
            "Amphibian Groups": 2,
            "Animal Groups": 32,
            "Bird Groups": 21,
            "Everyday Groups": 15,
            "Insect Groups": 5,
            "Marine Animal Groups": 5,
            "Reptile Groups": 2
        }
    },
    "Cricket": {
        "count": 178,
        "themes": {
            "Cricket World Cups": 27,
            "Grounds & History": 17,
            "IPL": 34,
            "Legends & Records": 52,
            "Rules & Terms": 31,
            "T20 & ICC Events": 17
        },
        "liveFrom": "2026-10-22"
    },
    "Currencies": {
        "count": 100,
        "themes": {
            "African Currencies": 6,
            "Asian Currencies": 31,
            "Cryptocurrencies": 6,
            "Currencies Named Peso": 1,
            "Currency Symbols": 10,
            "Currency Trading": 1,
            "Euro History": 1,
            "European Currencies": 12,
            "Historical Currencies": 11,
            "Major World Currencies": 7,
            "Middle Eastern Currencies": 3,
            "Pegged Currencies": 1,
            "South American Currencies": 5,
            "US Currency": 5
        }
    },
    "Emoji": {
        "count": 59,
        "themes": {
            "Animated Movies": 11,
            "Bollywood Films": 5,
            "Brands & Logos": 5,
            "Famous Places": 8,
            "Food Around the World": 8,
            "Hollywood Movies": 13,
            "Sayings & Idioms": 9
        },
        "liveFrom": "2026-10-31"
    },
    "Finance": {
        "count": 101,
        "themes": {
            "Advanced Instruments": 1,
            "Advanced Investing": 1,
            "Alternative Investments": 3,
            "Asset Pricing": 3,
            "Behavioral Finance": 5,
            "Capital Markets": 3,
            "Central Banking": 1,
            "Corporate Finance": 1,
            "Credit Derivatives": 1,
            "ESG & Sustainable Finance": 3,
            "Financial Metrics": 1,
            "Financial Theory": 1,
            "Fixed Income": 3,
            "Futures & Commodities": 3,
            "Investment Strategies": 4,
            "Investment Vehicles": 2,
            "Market Conditions": 5,
            "Market Microstructure": 2,
            "Options & Derivatives": 4,
            "Performance Measurement": 3,
            "Personal Finance": 12,
            "Portfolio Management": 2,
            "Private Equity": 2,
            "Real Estate Investing": 1,
            "Regulatory & Compliance": 6,
            "Retirement Planning": 5,
            "Risk Management": 3,
            "Stock Market Basics": 8,
            "Stock Valuation": 1,
            "Structured Finance": 3,
            "Swaps & Structured Products": 3,
            "Trading": 2,
            "Trading Strategies": 3
        }
    },
    "Flags": {
        "count": 72,
        "themes": {
            "African Flags": 5,
            "Arab Flags": 1,
            "Islamic World Flags": 3,
            "National Flags": 42,
            "Nordic Flags": 5,
            "Organizational Flags": 4,
            "Similar Flags": 2,
            "Symbolic Flags": 1,
            "US State Flags": 1,
            "Unique Flags": 8
        }
    },
    "Food": {
        "count": 96,
        "themes": {
            "Baking & Desserts": 4,
            "Cheese": 6,
            "Cocktails & Beverages": 1,
            "Coffee & Beverages": 10,
            "Fast Food": 1,
            "Food History": 3,
            "Food Science & Botany": 14,
            "Fruits & Vegetables": 3,
            "Indian Food & Drink": 5,
            "Ingredients": 12,
            "Middle Eastern Cuisine": 2,
            "Spices & Seasonings": 3,
            "World Cuisine": 32
        }
    },
    "Games": {
        "count": 100,
        "themes": {
            "Arcade Classics": 4,
            "Awards & Records": 1,
            "Battle Royale": 4,
            "Consoles & Hardware": 5,
            "Developers": 9,
            "Engines & Tools": 1,
            "Fallout Series": 1,
            "Franchises": 13,
            "Genres & Terms": 4,
            "God of War": 1,
            "Indie Games": 2,
            "Innovative Mechanics": 1,
            "JRPGs": 1,
            "MMORPGs": 1,
            "Mobile Games": 8,
            "Nintendo & Mario": 12,
            "Open World": 2,
            "Party & Social Games": 1,
            "Pokémon": 4,
            "Puzzle Games": 5,
            "Sales & Records": 2,
            "Sandbox & Building": 4,
            "Sega & Sonic": 3,
            "Shooters": 2,
            "Simulation": 2,
            "The Elder Scrolls": 1,
            "The Legend of Zelda": 3,
            "The Witcher": 2,
            "VR & Hardware": 1
        }
    },
    "Geography": {
        "count": 145,
        "themes": {
            "Borders & Neighbors": 3,
            "Capitals & Cities": 9,
            "Coastlines & Borders": 1,
            "Continents": 8,
            "Countries & History": 3,
            "Countries & Nicknames": 3,
            "Countries & Shapes": 2,
            "Countries & Size": 6,
            "Deserts & Arid Lands": 5,
            "Extremes": 3,
            "Historical Sites": 1,
            "Indian Geography": 25,
            "Islands & Archipelagos": 5,
            "Latitude & Longitude": 3,
            "Mountains": 11,
            "Natural Wonders": 11,
            "Oceans & Seas": 5,
            "Population": 2,
            "Rivers & Lakes": 24,
            "Time Zones & Borders": 1,
            "UNESCO Sites": 4,
            "US Geography": 2,
            "Volcanoes & Geology": 2,
            "Waterways": 6
        }
    },
    "History": {
        "count": 159,
        "themes": {
            "Age of Exploration": 5,
            "Ancient Civilizations": 19,
            "Ancient Wonders": 4,
            "Civil Rights & Suffrage": 2,
            "Cold War": 4,
            "Disasters": 1,
            "European History": 8,
            "Imperialism": 1,
            "Indian Festivals": 14,
            "Indian History": 60,
            "Modern History": 5,
            "Monuments & Landmarks": 2,
            "Pandemics & Disease": 2,
            "Political History": 1,
            "Science & Innovation": 1,
            "Space Race": 2,
            "US History": 8,
            "World History": 8,
            "World War I": 2,
            "World War II": 10
        }
    },
    "Hollywood": {
        "count": 129,
        "themes": {
            "Blockbusters & Franchises": 22,
            "Directors": 14,
            "Golden Age": 15,
            "Hollywood Meets India": 13,
            "Hollywood Trivia": 8,
            "Oscars & Awards": 26,
            "Stars": 31
        },
        "liveFrom": "2026-10-22"
    },
    "Indian Ads": {
        "count": 87,
        "themes": {
            "Automobile Ads": 5,
            "Celebrity Endorsements": 4,
            "Confectionery Ads": 5,
            "Corporate Ads": 3,
            "Detergent & Soap Ads": 3,
            "Electronics Ads": 3,
            "Fashion & Apparel": 3,
            "Financial Services Ads": 4,
            "Food Brands": 16,
            "Home Appliance Ads": 1,
            "Iconic Campaigns": 5,
            "Iconic Jingles": 6,
            "Paint & Home Decor Ads": 2,
            "Personal Care Ads": 4,
            "Social Campaign Ads": 5,
            "Soda & Beverage Ads": 8,
            "Telecom Ads": 7,
            "Vintage Ads": 2,
            "Viral / Parody Ads": 1
        }
    },
    "Indian Food": {
        "count": 160,
        "themes": {
            "Drinks": 13,
            "Food History": 10,
            "North Indian": 24,
            "Regional Cuisines": 18,
            "South Indian": 22,
            "Spices & Ingredients": 34,
            "Street Food": 14,
            "Sweets & Desserts": 25
        },
        "liveFrom": "2026-10-22"
    },
    "Internet": {
        "count": 99,
        "themes": {
            "Apps": 5,
            "Browsers": 1,
            "Emerging Tech": 1,
            "File Sharing": 1,
            "Indian Internet": 9,
            "Internet Culture": 10,
            "Internet Policy": 1,
            "Internet Slang & Acronyms": 21,
            "Mobile & Telecom": 1,
            "Online Safety": 2,
            "Platform History": 9,
            "Platforms": 9,
            "Programming & Development": 2,
            "Search Engines": 1,
            "Social Media": 5,
            "Social Media Origins": 2,
            "Tech Companies & Acquisitions": 5,
            "Web Basics": 10,
            "Web Protocols": 2,
            "Web Technologies": 1,
            "Websites": 1
        }
    },
    "Inventors": {
        "count": 85,
        "themes": {
            "Agricultural Inventions": 1,
            "Automotive Pioneers": 2,
            "Aviation Pioneers": 3,
            "Chemistry Inventions": 2,
            "Communication Inventions": 9,
            "Computer Pioneers": 5,
            "Electrical Inventions": 7,
            "Electronics Pioneers": 4,
            "Engines & Machines": 4,
            "Everyday Inventions": 21,
            "Historical Inventions": 1,
            "Household Inventions": 1,
            "Industrial Revolution": 7,
            "Internet Pioneers": 1,
            "Kitchen Inventions": 4,
            "Medical Breakthroughs": 8,
            "Medical Technology": 2,
            "Personal Care Inventions": 1,
            "Scientific Instruments": 2
        }
    },
    "Literature": {
        "count": 105,
        "themes": {
            "African American Literature": 2,
            "Allegorical Fiction": 2,
            "American Classics": 7,
            "Ancient Epics": 2,
            "Anti-War Literature": 1,
            "Children's Books": 6,
            "Children's Classics": 3,
            "Classic Novels": 13,
            "Detective Fiction": 2,
            "Dystopian Fiction": 7,
            "Existentialist Literature": 3,
            "Famous Opening Lines": 2,
            "Fantasy Series": 7,
            "Gothic Literature": 6,
            "Historical Mystery": 1,
            "Indian Literature": 28,
            "Japanese Literature": 1,
            "Latin American Literature": 1,
            "Medieval Literature": 1,
            "Modern Fantasy": 1,
            "Modern Fiction": 1,
            "Modern Literature": 1,
            "Non-Fiction": 1,
            "Nordic Noir": 1,
            "Philosophical Fiction": 1,
            "Playwrights": 1,
            "Russian Literature": 2,
            "Sci-Fi Humor": 1
        }
    },
    "Movies": {
        "count": 135,
        "themes": {
            "Action Franchises": 3,
            "Actors & Roles": 3,
            "Anime & Animation": 1,
            "Box Office": 2,
            "Classics & Top Rated": 8,
            "Comedy": 1,
            "Cult Classics": 2,
            "Directors: Christopher Nolan": 7,
            "Disney": 10,
            "Famous Directors": 9,
            "Fantasy Epics": 9,
            "Film Scores": 1,
            "Horror Movies": 3,
            "Iconic Movie Quotes": 7,
            "Indian Cinema": 14,
            "Leonardo DiCaprio Films": 1,
            "Oscar Winners": 4,
            "Pixar & Animation": 18,
            "Sci-Fi Cinema": 10,
            "Star Wars": 4,
            "Superhero Cinema": 14,
            "Titanic": 1,
            "Tom Hanks Films": 1,
            "Voice Acting Legends": 1,
            "Young Adult Adaptations": 1
        }
    },
    "Music": {
        "count": 132,
        "themes": {
            "Awards & Records": 1,
            "Classic Rock Bands": 6,
            "Classical Music": 7,
            "Folk & Singer-Songwriters": 2,
            "Genres": 1,
            "Hip-Hop": 2,
            "Indian Music": 45,
            "Instruments & Theory": 15,
            "Jazz": 1,
            "K-Pop": 3,
            "MTV & Music Videos": 1,
            "Michael Jackson & Pop Icons": 1,
            "Modern Pop": 15,
            "Music History": 2,
            "Music Industry": 1,
            "Pop Icons": 13,
            "R&B & Soul": 2,
            "Rock & Roll": 5,
            "Rock Bands": 6,
            "The Beatles": 3
        }
    },
    "Mythology": {
        "count": 108,
        "themes": {
            "Aztec Mythology": 2,
            "Celtic Mythology": 1,
            "Chinese Mythology": 2,
            "Egyptian Mythology": 7,
            "Greek Goddesses": 6,
            "Greek Heroes": 6,
            "Greek Mythology": 1,
            "Greek Myths": 9,
            "Greek Olympians": 6,
            "Greek Underworld": 1,
            "Hindu Mythology": 40,
            "Japanese Mythology": 1,
            "Mythical Creatures": 6,
            "Norse Cosmology": 3,
            "Norse Mythology": 12,
            "Roman Mythology": 5
        }
    },
    "Nature": {
        "count": 105,
        "themes": {
            "Ecosystems": 10,
            "Geology": 14,
            "India's National Symbols": 7,
            "Marine Ecosystems": 1,
            "Oceans & Atmosphere": 8,
            "Plants & Botany": 21,
            "Plants & Trees": 6,
            "Record-Breaking Organisms": 1,
            "Seasons & Climate": 7,
            "Sky & Space": 4,
            "Water Cycle": 5,
            "Weather & Natural Phenomena": 21
        }
    },
    "Nobel Prizes": {
        "count": 97,
        "themes": {
            "By Country": 1,
            "Categories": 4,
            "Ceremony": 7,
            "Chemistry": 1,
            "Elements": 1,
            "Firsts": 1,
            "History": 6,
            "Indian Laureates": 17,
            "Literature": 8,
            "Multiple Winners": 4,
            "Organizations": 6,
            "Peace Prize": 19,
            "Physics": 9,
            "Physiology or Medicine": 5,
            "Prize Money": 1,
            "Records": 1,
            "Refusals": 1,
            "Women Laureates": 5
        }
    },
    "Perfume": {
        "count": 83,
        "themes": {
            "Celebrity Fragrances": 3,
            "Classic Fragrances": 8,
            "Concentrations & Types": 6,
            "Fragrance Families": 4,
            "Fragrance Structure": 5,
            "Fragrance Terminology": 9,
            "Indian Perfumery": 8,
            "Ingredients & Notes": 18,
            "Modern Classics": 15,
            "Niche Houses": 4,
            "Perfume History": 2,
            "Perfumers & Noses": 1
        }
    },
    "Phobias": {
        "count": 83,
        "themes": {
            "Animal Phobias": 14,
            "Common Phobias": 1,
            "Contamination Phobias": 2,
            "Existential Phobias": 2,
            "Medical Phobias": 9,
            "Modern Phobias": 5,
            "Nature Phobias": 7,
            "Number Phobias": 4,
            "Pattern Phobias": 1,
            "Psychological Phobias": 1,
            "Situational Phobias": 11,
            "Social Phobias": 7,
            "Unusual Phobias": 14,
            "Weather Phobias": 4,
            "Word Phobias": 1
        }
    },
    "Science": {
        "count": 131,
        "themes": {
            "Biology & Animals": 11,
            "Chemistry & Materials": 33,
            "Earth Science": 7,
            "Famous Scientists": 14,
            "Human Body & Anatomy": 30,
            "Indian Scientists": 9,
            "Physics": 23,
            "Space & Planets": 4
        }
    },
    "Space": {
        "count": 109,
        "themes": {
            "Astronomy Concepts": 1,
            "Black Holes": 2,
            "Cosmic Phenomena": 6,
            "Cosmology": 3,
            "Earth Science": 1,
            "Exoplanets": 1,
            "Galaxies": 4,
            "Mars Exploration": 3,
            "Moons": 7,
            "Planetary Geology": 1,
            "Solar System": 28,
            "Space Agencies": 13,
            "Space History": 15,
            "Space Missions": 14,
            "Space Stations": 1,
            "Space Telescopes": 2,
            "Stars": 7
        }
    },
    "Sports": {
        "count": 148,
        "themes": {
            "American Football": 3,
            "Athletics": 2,
            "Baseball": 1,
            "Basketball": 7,
            "Bowling": 2,
            "Boxing": 2,
            "Cricket": 16,
            "Cycling": 1,
            "Football (Soccer)": 19,
            "Golf": 4,
            "Gymnastics": 2,
            "Ice Hockey": 3,
            "Indian Sports": 39,
            "Motorsport": 5,
            "Olympics": 9,
            "Rugby": 4,
            "Sailing": 1,
            "Snooker": 2,
            "Sports Origins & History": 7,
            "Swimming": 3,
            "Tennis": 15,
            "Volleyball": 1
        }
    },
    "TV": {
        "count": 150,
        "themes": {
            "Animated Sitcoms": 16,
            "Awards & History": 1,
            "Breaking Bad": 9,
            "Classic Sitcoms": 5,
            "Comedy": 2,
            "Drama": 19,
            "Friends": 14,
            "Game of Thrones": 9,
            "Indian Television": 37,
            "International Hits": 8,
            "Reality & Competition": 3,
            "Sci-Fi & Fantasy": 6,
            "Sitcoms": 10,
            "Stranger Things": 5,
            "The Office (US)": 6
        }
    },
    "Tech": {
        "count": 105,
        "themes": {
            "Companies & Products": 28,
            "Computer Hardware": 12,
            "Computer Science": 4,
            "Emerging Tech": 12,
            "File Formats & Extensions": 3,
            "Japanese Tech Innovations": 1,
            "Open Source": 1,
            "Programming": 8,
            "Software": 5,
            "Tech Founders & Pioneers": 12,
            "Tech History": 7,
            "Web & Internet Protocols": 7,
            "Wireless & Networking": 5
        }
    },
    "TrueCrime": {
        "count": 84,
        "themes": {
            "Art Heists": 2,
            "Bizarre Cases": 1,
            "Contract Killers": 1,
            "Cults": 5,
            "Domestic Terrorism": 1,
            "Famous Cases": 7,
            "Famous Heists": 1,
            "Famous Trials": 1,
            "Forensics": 11,
            "Historical Cases": 5,
            "Kidnapping": 1,
            "Legal": 8,
            "Mass Shootings": 2,
            "Missing Persons": 1,
            "Organized Crime": 5,
            "Pop Culture": 1,
            "Serial Killers": 21,
            "Terrorism": 1,
            "Unsolved Murders": 1,
            "Unsolved Mysteries": 5,
            "White-Collar Crime": 3
        }
    }
};
